import FormHeader from '../../../../common/FormHeader';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ResetRequested = ({ email }) => {
  const { t } = useTranslation();

  return (
    <div className="auth-page">
      <div className="form-reset">
        <FormHeader title={t('auth.resetSent', { email })} />
        <Link to="/signin" className="mg-btn mg-btn--primary mg-btn--block mg-mb-3">
          {t('auth.signIn')}
        </Link>
      </div>
    </div>
  );
};

export default ResetRequested;
